import {PsdkConst} from "./psdk_const";


/**
 * Write to device options
 */
export class WriteOptions {

  constructor(
    /**
     * Enable data splitting
     */
    public enableChunkWrite: boolean = true,
    /**
     * Part size
     */
    public chunkSize: number = PsdkConst.DEF_WRITE_CHUNK_SIZE,
    /**
     * Data write callback
     */
    public callback?: IDataWriteCallback,
  ) {

  }

  public static def(): WriteOptions {
    return new WriteOptions(
      true,
      PsdkConst.DEF_WRITE_CHUNK_SIZE,
      undefined
    );
  }
}


/**
 * Data write callback
 */
export abstract class IDataWriteCallback {
  abstract success(data: DataWrote): WriteControl;

  failed(data: DataWrite, exception: Error) {
    console.error(`Write data failed: ${exception.message}`)
  }
}

/**
 * Data write
 */
export class DataWrite {

  constructor(
    /**
     * Wrote binary
     */
    public binary: Uint8Array,
    /**
     * Write current times
     */
    public currentTimes: number,
    /**
     * Write total times
     */
    public totalTimes: number,
  ) {
  }

}

/**
 * Data wrote
 */
export class DataWrote extends DataWrite {

}

/**
 * Write control
 */
export enum WriteControl {

  CONTINUE = 'CONTINUE',
  STOP = 'STOP',

}
